(function() {
  'use strict';

  var glossary = window.SimpleLightingGlossary;
  if (!glossary || typeof glossary !== 'object') return;

  var template = document.getElementById('sl-tooltip-template');
  if (!template) return;

  var isTouchDevice = window.matchMedia('(hover: none)').matches;
  var activeTooltip = null;
  var activeTrigger = null;
  var showTimeout = null;
  var hideTimeout = null;
  var tooltipIdCounter = 0;

  /* ── Helpers ── */

  function clearTimers() {
    if (showTimeout) { clearTimeout(showTimeout); showTimeout = null; }
    if (hideTimeout) { clearTimeout(hideTimeout); hideTimeout = null; }
  }

  function positionTooltip(tooltip, trigger) {
    /* Reset position for measurement */
    tooltip.style.left = '0';
    tooltip.style.top = '0';
    tooltip.classList.remove('sl-tooltip--above');

    var triggerRect = trigger.getBoundingClientRect();
    var tooltipRect = tooltip.getBoundingClientRect();
    var viewportW = window.innerWidth;
    var viewportH = window.innerHeight;
    var margin = 12;
    var gap = 8;

    /* Default: below the trigger */
    var top = triggerRect.bottom + gap + window.scrollY;
    var left = triggerRect.left + (triggerRect.width / 2) - 20 + window.scrollX;

    /* Flip above if overflows viewport bottom */
    if (triggerRect.bottom + gap + tooltipRect.height > viewportH) {
      top = triggerRect.top - tooltipRect.height - gap + window.scrollY;
      tooltip.classList.add('sl-tooltip--above');
    }

    /* Shift left if overflows viewport right */
    var leftInViewport = left - window.scrollX;
    if (leftInViewport + tooltipRect.width > viewportW - margin) {
      left = (viewportW - margin - tooltipRect.width) + window.scrollX;
    }

    /* Don't go past left edge */
    if (left - window.scrollX < margin) {
      left = margin + window.scrollX;
    }

    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
  }

  function showTooltip(trigger, key) {
    /* Close any existing tooltip */
    if (activeTooltip) hideTooltipImmediate();

    var data = glossary[key];
    if (!data) return;

    /* Clone template */
    var tooltipEl = template.querySelector('.sl-tooltip').cloneNode(true);
    var id = 'sl-tooltip-' + (++tooltipIdCounter);
    tooltipEl.id = id;

    tooltipEl.querySelector('.sl-tooltip__term').textContent = data.term;
    tooltipEl.querySelector('.sl-tooltip__definition').textContent = data.definition;

    var learnMoreLink = tooltipEl.querySelector('.sl-tooltip__learn-more');
    if (data.learnMore) {
      learnMoreLink.href = data.learnMore;
    } else {
      learnMoreLink.href = '#';
    }

    /* Append to body for absolute positioning */
    document.body.appendChild(tooltipEl);

    /* Set aria attributes */
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-describedby', id);

    activeTooltip = tooltipEl;
    activeTrigger = trigger;

    /* Position */
    positionTooltip(tooltipEl, trigger);

    /* Animate in */
    requestAnimationFrame(function() {
      tooltipEl.classList.add('sl-tooltip--visible');
    });

    /* Desktop: hover on tooltip keeps it open */
    if (!isTouchDevice) {
      tooltipEl.addEventListener('mouseenter', function() {
        clearTimers();
      });
      tooltipEl.addEventListener('mouseleave', function() {
        scheduleHide();
      });
    }
  }

  function hideTooltipImmediate() {
    clearTimers();
    if (!activeTooltip) return;

    activeTooltip.classList.remove('sl-tooltip--visible');
    var tooltip = activeTooltip;

    setTimeout(function() {
      if (tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
    }, 150);

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.removeAttribute('aria-describedby');
    }

    activeTooltip = null;
    activeTrigger = null;
  }

  function scheduleHide() {
    clearTimers();
    hideTimeout = setTimeout(hideTooltipImmediate, 300);
  }

  /* ── Initialise triggers ── */

  var targets = document.querySelectorAll('[data-glossary-key]');

  targets.forEach(function(el) {
    var key = el.getAttribute('data-glossary-key');
    var data = glossary[key];
    if (!data) return;

    /* Create trigger button */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sl-tooltip-trigger';
    btn.textContent = 'i';
    btn.setAttribute('aria-label', 'What is ' + data.term + '?');
    btn.setAttribute('aria-expanded', 'false');
    btn.dataset.glossaryTrigger = key;

    /* Insert inside the target element as last child */
    el.appendChild(btn);

    if (isTouchDevice) {
      /* Mobile: tap to toggle */
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (activeTrigger === btn) {
          hideTooltipImmediate();
        } else {
          showTooltip(btn, key);
        }
      });
    } else {
      /* Desktop: hover + focus */
      btn.addEventListener('mouseenter', function() {
        clearTimers();
        showTimeout = setTimeout(function() {
          showTooltip(btn, key);
        }, 200);
      });

      btn.addEventListener('mouseleave', function() {
        clearTimers();
        scheduleHide();
      });

      btn.addEventListener('focus', function() {
        clearTimers();
        showTooltip(btn, key);
      });

      btn.addEventListener('blur', function() {
        scheduleHide();
      });
    }
  });

  /* ── Global event handlers ── */

  /* Escape key closes tooltip */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeTooltip) {
      var trigger = activeTrigger;
      hideTooltipImmediate();
      if (trigger) trigger.focus();
    }
  });

  /* Tap outside closes tooltip (mobile) */
  if (isTouchDevice) {
    document.addEventListener('touchstart', function(e) {
      if (!activeTooltip) return;
      if (activeTrigger && activeTrigger.contains(e.target)) return;
      if (activeTooltip && activeTooltip.contains(e.target)) return;
      hideTooltipImmediate();
    });
  }

})();
